import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private fns: AngularFireFunctions,
    private firestore: AngularFirestore
  ) {}

  register(name: string, email: string, phoneNumber: string, password: string, dob: string, sex: number, emailVerified = false): Observable<any> {
    const registerUserCallable = this.fns.httpsCallable('registerUser');
    return registerUserCallable({
      name,
      email,
      phoneNumber,
      password,
      dob,
      sex,
      emailVerified
    });
  }

  registerFB(name: string, email: string, phoneNumber: string, dob: string, sex: number): Observable<any> {
    const registerFacebookUser = this.fns.httpsCallable('registerFacebookUser');
    return registerFacebookUser({ name, email, phoneNumber, dob, sex });
  }

  public checkExistUser(email: string): Observable<boolean> {
    const checkExistUserCallable = this.fns.httpsCallable('checkExistUser');
    return checkExistUserCallable({ email });
  }

  sendEmailOtp(email: string): Observable<any> {
    const sendEmailOtpCallable = this.fns.httpsCallable('sendEmailOtp');
    return sendEmailOtpCallable({ email });
  }

  verifyEmailOtp(email: string, code: string): Observable<any> {
    const verifyEmailOtpCallable = this.fns.httpsCallable('verifyEmailOtp');
    return verifyEmailOtpCallable({ email, code });
  }

  public checkExistStudent(): Observable<boolean> {
    const checkExistStudentCallable = this.fns.httpsCallable('checkExistStudent');
    return checkExistStudentCallable({});
  }

  async checkUser(uid: string): Promise<any> {
    const doc = await this.firestore.collection('users').doc(uid).get().toPromise();
    return doc ? doc.data() : null;
  }
}
